import { createAction, props } from '@ngrx/store'
import { Player, PlayerComparisonRequest, PlayerRequest, PlayerSummary } from '@core/models/player.models'
import { Match } from '@core/models/match.models'
import { MetricMap } from '@core/models/metric.models'
import { PlayerPosition } from '@core/enums/player.enums'

export const fetchPlayerSummary = createAction('[Player Detail] fetch player summary', props<PlayerRequest>())

export const fetchPlayerDetailData = createAction('[Player Detail] fetch player detail data')

export const setPlayerSummary = createAction('[Player Detail] set player summary', props<{ summary: PlayerSummary }>())
export const setPlayerALoader = createAction(
  '[Player Detail] set player summary loader',
  props<{ playerALoading: boolean }>()
)

export const fetchPlayerDetailMetrics = createAction(
  '[Player Detail] fetch player metrics',
  props<{ summary: PlayerSummary }>()
)

export const setPlayerMetrics = createAction('[Player Detail] set player metrics', props<{ metrics: MetricMap }>())
export const setPlayerMetricsLoader = createAction(
  '[Player Detail] set player metrics loader',
  props<{ metricsLoading: boolean }>()
)

export const fetchMatchPlayer = createAction('[Player Detail] fetch match player', props<PlayerRequest>())

export const setMatchPlayer = createAction('[Player Detail] set match', props<{ match: Match }>())

export const comparePlayers = createAction(
  '[Player Detail] compare players',
  props<{ comparison: PlayerComparisonRequest }>()
)

export const compareMatchPlayers = createAction(
  '[Player Detail] compare match players',
  props<{ matchId: string; comparison: PlayerComparisonRequest }>()
)

export const setPlayerB = createAction('[Player Detail] set playerB', props<{ playerB: PlayerSummary }>())
export const setPlayerBLoader = createAction('[Player Detail] set playerB loader', props<{ playerBLoading: boolean }>())

export const setToComparePlayer = createAction(
  '[Player Detail] set to compare player',
  props<{ toComparePlayer: Player }>()
)

export const navigatePlayer = createAction(
  '[Player Detail] navigate',
  props<{ payload: { playerA: Player; playerB: Player; position: PlayerPosition | string } }>()
)

export const purgePlayerDetail = createAction('[Player Detail] purge player detail')

export const purgePlayerModal = createAction('[Player Detail] purge modal')

export const setPlayerTabs = createAction('[Player Detail] set player tabs', props<{ tabs: string[] }>())
export const setPlayerActiveTabIndex = createAction(
  '[Player Detail] set player active tab index',
  props<{ activeTabIndex: number }>()
)
export const setPlayerComparisonActiveTabIndex = createAction(
  '[Player Detail] set player comparison active tab index',
  props<{ comparisonActiveTabIndex: number }>()
)
